<template>
  <div class="tab__Item">
    <error-prompt class="error--Modal" :errors="errors"></error-prompt>
    <div class="formSection">
      <div class="formSection__Row">
        <div class="formSection__Columns--Editor">
          <div class="formSection__Column">
            <label class="formLabel" for="email">{{ $store.getters.getStringTranslation('email') }}</label>
            <input v-model="email" class="formInput" type="email" id="email" />
          </div>
          <div class="formSection__Column">
            <label class="formLabel" for="email">{{ $store.getters.getStringTranslation('fullName') }}</label>
            <input v-model="name" class="formInput" type="email" id="email" />
          </div>
        </div>
        <button @click="inviteUser()" class="button">{{ $store.getters.getStringTranslation('sendInv') }}</button>
      </div>
    </div>
    <success-prompt :updated="updated" message="Success! Invite sent to user."></success-prompt>
    <loader class="imageLoader" :loading="loading" />
  </div>
</template>

<script>
import HTTP from '@/http-common.js'

import Loader from '@/components/partials/Loader.vue'
import SuccessPrompt from '@/components/editor/SuccessPrompt.vue'
import ErrorPrompt from '@/components/editor/ErrorPrompt.vue'

export default {
  name: 'Invite',
  components: {
    Loader,
    SuccessPrompt,
    ErrorPrompt,
  },
  data() {
    return {
      loading: false,
      email: '',
      name: '',
      prompt: {
        success: '',
      },
      updated: false,
      errors: [],
    }
  },
  computed: {
    org() {
      return this.$store.state.accounts.org
    },
  },
  methods: {
    inviteUser() {
      this.loading = true
      HTTP.post(`org/${this.org.id}/invite`, {
        email: this.email,
        name: this.name,
        is_org_admin: false,
      })
        .then(() => {
          this.updated = true
          this.loading = false

          // Enable edit
          setTimeout(() => {
            this.updated = false
          }, 3000)
        })
        .catch((e) => {
          this.loading = false
          this.errors = e.response ? e.response.data : console.error(e)
        })
    },
  },
}
</script>
